import AuthShowcase from './AuthShowcase.jsx'

export default function AuthFormShell({
  showcaseTitle,
  showcaseDescription,
  showcaseStats,
  showcaseVariant,
  children,
}) {
  return (
    <div className="auth-shell">
      <AuthShowcase
        title={showcaseTitle}
        description={showcaseDescription}
        stats={showcaseStats}
        variant={showcaseVariant}
      />
      <div className="auth-right">{children}</div>
    </div>
  )
}
